/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { IAppState } from 'src/store';
import { Text } from 'src/components/common';
import { People } from 'src/dataFactory/depositionFactory';
import { depositionAction } from 'src/redux/depositionRedux';

const CourtReporterText: React.FC<Props> = ({ involvedPartiesUri, onGetDepositionInvoledParties }) => {
  const [addedParties, setAddedParties] = useState<People[]>([]);

  useEffect(() => {
    fetchData();
  }, []);

  function fetchData() {
    onGetDepositionInvoledParties({ uri: involvedPartiesUri }, res => setAddedParties(res), fetchDataFailed);
  }

  const fetchDataFailed = (error: any) => {
    console.log('CourtReporterText', error);
  };

  const courtReporter = addedParties.find(p => p.role === 'COURT_REPORTER');
  if (courtReporter) {
    return <Text>{courtReporter.name}</Text>;
  }
  return <Text>-- --</Text>;
};

type Props = ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps & { involvedPartiesUri: string };

const mapStateToProps = (state: IAppState) => ({});

const mapDispatchToProps = {
  onGetDepositionInvoledParties: depositionAction.getDepositionInvoledParties,
};

export default connect(mapStateToProps, mapDispatchToProps)(CourtReporterText);
